import { gql } from '@src/lib/gql'

/** Drop the open tool draft and the suggested reply. Does not publish. */
export const DISCARD_TOOL_DRAFT = gql`
  mutation DiscardToolDraft($input: DiscardToolDraftInput!) {
    discardToolDraft(input: $input) {
      discarded
    }
  }
`
